import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-0-small', 'Number0Small', [["path",{"d":"M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0","key":"svg-0"}]]);